/*
 * Reverse engineering of:
 *
 * https://github.com/backstage/backstage/blob/master/plugins/scaffolder-react/src/next/components/Stepper/Stepper.tsx
 *
 * Summary of changes with all transitive dependencies:
 *
 * - Wrap wordy sndt questions (aka scaffolder parameter titles)
 * - Do NOT Apply A Funky Head Case To Questions As It Does Not Make Sense At All
 *
 */
import { ReviewStepProps } from '@backstage/plugin-scaffolder-react'
import { Button, makeStyles } from '@material-ui/core'
import { ReviewState } from './ReviewState'

const useStyles = makeStyles(
  theme => ({
    backButton: {
      marginRight: theme.spacing(1)
    },
    footer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'right',
      marginTop: theme.spacing(2)
    },
    formWrapper: {
      padding: theme.spacing(2)
    }
  }),
  { name: 'CustomTemplateStepper' }
)

export function CustomReviewStep(props: ReviewStepProps) {
  const { steps, formData, disableButtons, handleBack, handleCreate } = props
  const styles = useStyles()
  return (
    <>
      <ReviewState formState={formData} schemas={steps as any} />
      <div className={styles.footer}>
        <Button
          onClick={handleBack}
          className={styles.backButton}
          disabled={disableButtons}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreate}
          disabled={disableButtons}
        >
          Create
        </Button>
      </div>
    </>
  )
}
